export var InputLatency;
(function (InputLatency) {
    /** Per-track override sentinel: inherit the value from the engine preferences. */
    InputLatency.Inherit = -2.0;
    /** Treat the input latency as equal to the output latency (doubles the compensation). */
    InputLatency.EqualsOutput = -1.0;
    /**
     * Resolves the additional latency (in seconds) to add to the output latency when recording.
     * @param localOverride the per-track value stored in the CaptureAudioBox
     * @param preference the engine-preferences default
     * @param outputLatency the current output latency in seconds
     */
    InputLatency.resolve = (localOverride, preference, outputLatency) => {
        const value = localOverride <= InputLatency.Inherit ? preference : localOverride;
        return value === InputLatency.EqualsOutput ? outputLatency : Math.max(0, value);
    };
})(InputLatency || (InputLatency = {}));
